import { useBranding } from "@/context/BrandingContext";

export function PolicyLinks({ className = "" }) {
  const { privacy, branding } = useBranding();
  const links = [
    privacy.privacy_enabled !== false && privacy.privacy_policy_url && ["Privacy Policy", privacy.privacy_policy_url, "footer-privacy-link"],
    privacy.terms_url && ["Terms & Conditions", privacy.terms_url, "footer-terms-link"],
    branding.support_email && ["Contact", `mailto:${branding.support_email}`, "footer-contact-link"],
    branding.instagram_url && ["Instagram", branding.instagram_url, "footer-instagram-link"],
  ].filter(Boolean);
  if (!links.length) return null;
  return (
    <div className={`flex flex-wrap gap-x-5 gap-y-2 ${className}`}>
      {links.map(([t, href, id]) => (
        <a key={id} href={href} target="_blank" rel="noreferrer" className="hover:text-primary transition-colors" data-testid={id}>{t}</a>
      ))}
    </div>
  );
}

export function Footer() {
  const { branding } = useBranding();
  return (
    <footer className="border-t border-border/70 mt-16 py-8 text-xs text-muted-foreground" data-testid="site-footer">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <p className="font-display text-sm text-foreground">{branding.website_name}</p>
          <p className="mt-0.5">{branding.tagline}</p>
        </div>
        <PolicyLinks />
        <p data-testid="footer-copyright">© {new Date().getFullYear()} {branding.website_name}</p>
      </div>
    </footer>
  );
}
